var map = {
	"./cyber-security.jpg": 54804,
	"./microsoft-365.jpg": 57575,
	"./microsoft-azure.jpg": 52334,
	"./power-automate.jpg": 58096,
	"./power-bi.jpg": 70585,
	"./students.jpg": 75326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76549;